var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 10,
    fill: "#F5F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5457 22.8509V20.7525C14.5457 20.2208 14.9781 19.7888 15.5137 19.7855H17.4802C18.0182 19.7855 18.4543 20.2184 18.4543 20.7525V22.8448C18.4543 23.306 18.8291 23.6808 19.2936 23.6842H20.6353C21.2619 23.6858 21.8634 23.4398 22.307 23.0005C22.7507 22.5612 23 21.9646 23 21.3425V15.3819C23 14.8794 22.7756 14.4027 22.3874 14.0803L17.8294 10.4613C17.0327 9.82835 15.8947 9.8488 15.1216 10.51L10.6616 14.0803C10.255 14.3932 10.012 14.8713 10 15.3819V21.3364C10 22.6331 11.0587 23.6842 12.3648 23.6842H13.6758C13.8994 23.6858 14.1145 23.5987 14.2732 23.4423C14.4319 23.2858 14.5212 23.073 14.5212 22.8509H14.5457Z",
    fill: "#C59331"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/homeIcon.dd755f23757b2323b9c78f1fb27ddeab.svg";